/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { exploreWithSampleData } from './exploreWithSampleData';

const initialState = {
  status: 'idle',
};

const setupSampleDataSlice = createSlice({
  name: 'setupSampleData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(exploreWithSampleData.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(exploreWithSampleData.fulfilled, (state) => {
        state.status = 'idle';
      })
      .addCase(exploreWithSampleData.rejected, (state, action) => {
        if (action.meta?.condition) return;
        state.status = 'failed';
      });
  },
});

export default setupSampleDataSlice.reducer;
